const NotificationApiPaths = {
  GetUserNotificationPagedFilterDIP:
    'Dip-Notification/api/Notification/GetUserNotificationPagedFilterRIV',
  GetReceiverNotifications: 'Dip-Notification/api/Notification/GetReceiverNotifications',
  MarkNotificationListedAsSeenDIP:
    'Dip-Notification/api/Notification/MarkNotificationListedAsSeenRIV',
  MarkAllReceivedAsListedDIP: 'Dip-Notification/api/Notification/MarkAllReceivedAsListedRIV',
  MarkAllListedAsSeenDIP: 'Dip-Notification/api/Notification/MarkAllListedAsSeenRIV',
}

export default NotificationApiPaths
